module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/efo_features_14-a65686e2fe4424ab0833fbd2526f2e2b.png";